import { View } from 'foundations-components/components/View';
import { VideoPlayerWithControls } from '../../features/video';
import { InteractiveEducationLayout } from '../../features/interactiveEducation/components/InteractiveEducationLayout';
import { useUserIndustry } from '../../features/interactiveEducation/hooks/useUserIndustry';
import { extractVideoMetadata, buildInteractiveContentTrackingProps } from '../../features/interactiveEducation/utils/contentUtils';
import { useGenerateAsyncSummarization } from '../../features/interactiveEducation/hooks/useGenerateAsyncSummarization';
import { useInteractiveEducation } from '../../features/interactiveEducation/hooks/useInteractiveEducation';
import getLang from '../../utils/getLang';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrackContentWithInteractiveEducation = ({
  lesson,
  lessonQuizProps,
  track,
  onAdvanceContent,
  videoContent
}) => {
  var _lessonQuizProps$capt, _lessonQuizProps$capt2;
  const language = track.language || getLang();
  const isPubliclyVisible = lesson.visibility === 'PUBLIC';
  const {
    contentPortalId,
    professorId,
    videoId: extractedVideoId
  } = extractVideoMetadata(videoContent);

  // Ensure videoId is a number or undefined (handle string/NaN cases)
  const videoId = extractedVideoId != null && !isNaN(Number(extractedVideoId)) ? Number(extractedVideoId) : undefined;
  const trackingPropsSource = Object.assign({}, videoContent, {
    hsSoftwareFilters: track.hsSoftwareFilters,
    subCategories: track.subCategories,
    useCases: lesson.useCases
  });
  const {
    label: industry
  } = useUserIndustry();
  const interactiveContentTrackingProps = buildInteractiveContentTrackingProps({
    content: trackingPropsSource,
    contentType: 'TRACK',
    contentId: videoContent.id,
    professorId,
    industry,
    visibility: track.visibility
  });
  const {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation,
    interactiveEducationEnabled
  } = useInteractiveEducation({
    videoId,
    hasCaptions: (_lessonQuizProps$capt = (_lessonQuizProps$capt2 = lessonQuizProps.captionsExistMap) === null || _lessonQuizProps$capt2 === void 0 ? void 0 : _lessonQuizProps$capt2[String(videoContent.id)]) !== null && _lessonQuizProps$capt !== void 0 ? _lessonQuizProps$capt : false,
    interactiveContentTrackingProps
  });
  const {
    summary,
    correlationId: summaryCorrelationId,
    summaryError,
    summaryLoading,
    refetchSummary,
    videoDuration
  } = useGenerateAsyncSummarization({
    primaryContentId: lesson.id,
    contentType: 'LESSON',
    lessonContentId: videoContent.id
  });
  const interactiveEducationProps = {
    handleTriggerAsyncQuizGeneration: lessonQuizProps.regenerateQuiz,
    generateQuizError: lessonQuizProps.generateQuizError,
    generateQuizLoading: lessonQuizProps.generateQuizLoading,
    onRegenerateSingleVideoQuiz: lessonQuizProps.regenerateSingleVideoQuiz,
    summary,
    summaryCorrelationId,
    summaryError,
    summaryLoading,
    refetchSummary,
    videoDuration: videoDuration !== null && videoDuration !== void 0 ? videoDuration : undefined
  };
  return /*#__PURE__*/_jsx("div", {
    "data-contentid": videoContent.id,
    "data-test-id": "stored-content-container",
    children: /*#__PURE__*/_jsx(InteractiveEducationLayout, {
      contentPortalId: contentPortalId,
      contentType: "LESSON",
      displayInteractiveEducation: displayInteractiveEducation,
      interactiveContentTrackingProps: interactiveContentTrackingProps,
      interactiveEducationEnabled: interactiveEducationEnabled,
      interactiveEducationProps: interactiveEducationProps,
      lesson: lesson,
      lessonContentId: videoContent.id,
      primaryContentId: lesson.id,
      videoId: videoId,
      videoTitle: videoContent.name,
      children: /*#__PURE__*/_jsx(View, {
        borderColor: "border-core-subtle",
        borderRadius: "300",
        borderStyle: "solid",
        borderWidth: "100",
        overflow: "hidden",
        children: /*#__PURE__*/_jsx(VideoPlayerWithControls, {
          additionalTracking: interactiveContentTrackingProps,
          contentId: videoContent.id.toString(),
          displayInteractiveEducation: displayInteractiveEducation,
          enableAdaptToIndustry: true,
          enableQuizMe: true,
          enableSummarize: true,
          handleDisplayInteractiveEducation: handleDisplayInteractiveEducation,
          interactiveEducationEnabled: interactiveEducationEnabled,
          isPubliclyVisible: isPubliclyVisible,
          language: language,
          lessonId: String(lesson.id),
          lessonName: lesson.name,
          onFinish: onAdvanceContent,
          trackId: track.id,
          trackName: track.name
        })
      })
    })
  });
};
export default TrackContentWithInteractiveEducation;